export default {"src":"/_next/static/media/download.55f0d4b4.svg","height":30,"width":30};